export default __webpack_public_path__ + "static/media/587.9f05df23.png";